import { createReducer, on } from '@ngrx/store';

import {
  clearSpaceTemplateData,
  loadAllCategoriesFailed,
  loadAllCategoriesSuccess,
  loadAllSpaceTemplates,
  loadAllSpaceTemplatesFailed,
  loadAllSpaceTemplatesSuccess,
} from './space-template.actions';
import {
  RestSharedInspectionSpaceCategory,
  RestSpaceTemplateModel,
} from '../models/rest-space-template-model.interface';

export const spaceTemplateFeatureKey = 'space-template';

export interface SpaceTemplateState {
  listItemsLoading?: boolean;
  listItems?: RestSpaceTemplateModel[];
  categories?: RestSharedInspectionSpaceCategory[];

  entityUpdateOngoing?: boolean;
  deleteEntityOngoing?: boolean;
}

export const initialState: SpaceTemplateState = {
  listItemsLoading: false,
  entityUpdateOngoing: false,
  deleteEntityOngoing: false,
};

export const reducer = createReducer(
  initialState,
  /* Templates List */
  on(loadAllSpaceTemplates, (state, action) => ({ ...state, listItemsLoading: true })),
  on(loadAllSpaceTemplatesSuccess, (state, action) => ({
    ...state,
    listItemsLoading: false,
    listItems: action.listItems,
    deleteEntityOngoing: false,
  })),
  on(loadAllSpaceTemplatesFailed, (state, action) => ({
    ...state,
    listItemsLoading: false,
    listItems: [],
    deleteEntityOngoing: false,
  })),
  on(clearSpaceTemplateData, (state, action) => ({
    ...state,
    listItemsLoading: false,
    entityUpdateOngoing: false,
    deleteEntityOngoing: false,
  })),
  on(loadAllCategoriesSuccess, (state, action) => ({
    ...state,
    categories: action.categoriesList,
  })),
  on(loadAllCategoriesFailed, (state, action) => ({
    ...state,
    unitTypes: [],
  }))
);
